import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import kwootLogoYellow from '../kwoot/logo-yellow.svg';
import './menu.css';
import { connect } from 'react-redux';
import { toggleMenuAction } from '../../actions/siteActions';

import menuCloseIcon from './icon-menu-close.svg';

class Menu extends Component {

    constructor(props) {
        super(props);

        this.toggleMenu = this.toggleMenu.bind(this);
    }

    toggleMenu(e) {
        e.preventDefault();
        this.props.dispatch(toggleMenuAction());
    }


    render() {

        let style = {};

        if (!this.props.site.menuOpen) {
            style = { display: 'none' };
        }

        return (
            <nav className="menu" style={style}>
                <ul className="menuitems">
                    <li className="closeit"><a href="#" onClick={this.toggleMenu.bind(this)}><img className="menuCloseIcon" alt="Close menu" src={menuCloseIcon} title="Sluit menu"/></a></li>
                    <li className="menuitem"><Link to="/" className="menulink">Home</Link></li>
                    <li className="menuitem"><Link to="/diensten" className="menulink">Wat we doen</Link></li>
                    <li className="menuitem"><Link to="/ons-werk" className="menulink">Waar we trots op zijn</Link></li>
                    <li className="menuitem"><Link to="/actueel" className="menulink">Wat ons bezighoudt</Link></li>
                    <li className="menuitem"><Link to="/de-mensen-van-kwoot" className="menulink">Wie we zijn</Link></li>
                    <li className="menuitem"><Link to="/contact" className="menulink">Contact</Link></li>
                </ul>

                <Link to="/" className="home"><img className="sidebar__kwootLogoYellow" src={kwootLogoYellow} alt="Kwoot logo"/></Link>

            </nav>
        );
    }
}

const mapStateToProps = (store) => {
    return {
        site: store.site,
    };
};

export default connect(mapStateToProps)(Menu);


// WEBPACK FOOTER //
// ./src/components/menu/menu.js